import React, { useEffect, useState, useContext } from 'react';
import { useParams  } from "react-router-dom";
import helpers from '../../../services/helpers';
import { httpRequest } from '../../../services/httpService';
import Swal from 'sweetalert2';
import Loader from '../../parts/Loader';
import store from '../../../services/store';
import images from '../../../services/images';
import initTreeView from '../../../services/initTreeView';
import StoreInfo from '../../parts/StoreInfo';
import FormContext from '../../../services/formContext';

export default function SalesOrderPrintView (){
    const {
        account
    } = useContext(FormContext);
    const default_currency = helpers.getSettingValue(account?.settings, 'default_currency', 'PHP');
    const tax_enabled = helpers.getSettingValue(account?.settings, 'tax_enabled', 1);
    const discount_enabled = helpers.getSettingValue(account?.settings, 'discount_enabled', 1);
    const single_label = helpers.getSettingValue(account?.settings, 'sales_order_single_label', 'Sales Order');

    const { order_id } = useParams();
    const [loading, setLoading] = useState(1);
    const [record_loaded, setRecordLoaded] = useState(0);
    const [record_data, setRecordData] = useState(store.sales_order_data);
    const [record_items, setRecordItems] = useState([]);
    const [table_items, setTableItems] = useState([]);
   
    useEffect(() => {
        initTreeView()
        if(order_id){
            getData(order_id)
        }
    }, []);

    useEffect(() => {
        displayTableItems()
    }, [record_items]);

    function getData(order_id){
        if(!order_id){
            return
        }
        const url = helpers.createUrl(`V1/manage/order/sales/${order_id}?store_id=${helpers.getStoreID()}`)

        setLoading(1)
        httpRequest(url, "GET", {}, true)
        .then((res) => {
            let items = res;
            items.order_date = new Date(res.order_date)

            setLoading(0)
            setRecordData(items)
            setRecordItems(items.items)
            setRecordLoaded(1)
            
            setTimeout(function(){
                window.print()
            }, 2000);
        })
        .catch((err) => {
            setLoading(0)

            Swal.fire({
                //title: err.message,
                text: err.message,
                icon: "error",
                confirmButtonText: "OK",
                allowOutsideClick: false
            })
            .then((result) => {
                if (result.isConfirmed) {
                    window.location.replace("/sales/list");
                }
            })
        }); 

    }
    function computeSubTotals(){
        let items = 0;
        let total_amount = 0

        record_items.forEach((data) => {
            const quantity = parseInt(data.quantity ?? '0', 10);
            const price = parseFloat(data.amount ?? '0');
            const discount = parseFloat(data.discount_amount ?? '0');

            const totalPrice = price * quantity
            const netPrice = totalPrice - discount;

            items += quantity;
            total_amount += netPrice
        });

        return helpers.formatCurrencyAmount(total_amount, default_currency);
    }

    function displayTableItems(){
        let items = []
        
        if (record_items.length) {
            items = Object.entries(record_items).map(([key, data]) => {
                return(
                <tr>
                    <td>
                        <div className='mb-0'>{data.product_name}{data.product_variant_name != 'Generic' ? ` (${data.product_variant_name})` : ''}</div>
                        <div><small>SKU: {data.product_code}</small></div>
                        {data.product_description ? <div className='mt-1'><small style={{whiteSpace: 'pre-line'}}>{data.product_description}</small></div> : ''}
                    </td>
                    {/* <td>{data.product_code}</td> */}
                    <td>{data.quantity}{data.unit_name ? ` ${data.unit_name}` : ''}</td>
                    <td>{helpers.formatCurrencyAmount(data.amount, default_currency)}</td>
                    {parseInt(discount_enabled) ? 
                    <td>
                        {helpers.formatCurrencyAmount(data.discount_amount, default_currency)}<br/>
                        <small>{data.discount_name ? `(${data.discount_name})` : ''}</small>
                    </td> : ''
                    }
                    <td>{helpers.formatCurrencyAmount(data.total_amount, default_currency)}</td>
                </tr>)

            })
        }

        setTableItems(<tbody>{items}</tbody>)
    }

    return (
        <div className="invoice p-4 mb-3">
        <Loader isLoading={loading}/>
            <div className="d-flex justify-content-between mb-3">
                <StoreInfo store={record_data.store_info} />

                <div className='text-right'>
                    <h2><strong>{helpers.capitalizeString(single_label)}</strong></h2>
                    {/* <h5>{helpers.displayOrderStatusBadge(record_data.order_status_id, record_data.order_status)}</h5> */}
                    <h5 className='mb-0'>{record_data.order_no ? `Reference No: ${record_data.order_no}` : '---'}</h5>
                </div>
            </div>

            <div className="row">
                <div className="col-4 mb-3">
                    <h5 className='mb-0'><b>Bill To:</b></h5>
                    <div>
                        <p className='mb-0'><b>{record_data.customer_name}</b></p>
                        <p className='mb-0'>{record_data.billing_address}</p>
                        <p className='mb-0'>{record_data.billing_phone}</p>
                    </div>
                </div>
                <div className="col-4 mb-3">
                    <h5 className='mb-0'><b>Ship To:</b></h5>
                    <div>
                        <p className='mb-0'><b>{record_data.shipping_contact_name}</b></p>
                        <p className='mb-0'>{record_data.shipping_address}</p>
                        <p className='mb-0'>{record_data.shipping_phone}</p>
                    </div>
                </div>
                <div className="col-4 text-lg-right mb-2">
                    <table className='table table-borderless table-sm'>
                        <tbody>
                            {/* <tr>
                                <td className='py-0'><b>Order No:</b></td>
                                <td className='py-0'>{record_data.order_no ? record_data.order_no : '---'}</td>
                            </tr> */}
                            <tr>
                                <td className='py-0'><b>Date:</b></td>
                                <td className='py-0'>{record_loaded ? helpers.formatDate(record_data.order_date) : '---'}</td>
                            </tr>
                            <tr>
                                <td className='py-0'><b>Terms:</b></td>
                                <td className='py-0'>{record_data.payment_term ? record_data.payment_term : '---'}</td>
                            </tr>
                            {/* <tr>
                                <td className='py-0'><b>Shipment Status:</b></td>
                                <td className='py-0'>{record_data.shipping_status ? record_data.shipping_status : '---'}</td>
                            </tr> */}
                            {
                                record_data.order_status_id == 4
                                ?
                                <tr>
                                    <td className='py-0'><b>Reason:</b></td>
                                    <td className='py-0'>{record_data.reason}</td>
                                </tr> : ''
                            }
                        </tbody>
                    </table>
                </div>
            </div>

            <div className='table-responsive'>
                <table className='table table-striped table-sm border-bottom'>
                    <thead>
                        <tr>
                            <th>Item</th>
                            {/* <th>SKU</th> */}
                            <th>Quantity</th>
                            <th>Price</th>
                            {/* <th>Tax</th> */}
                            {parseInt(discount_enabled) ? <th>Discount</th> : ''}
                            <th>Amount</th>
                        </tr>
                    </thead>
                    {
                        table_items
                    }
                </table>
            </div>

            <div className='row'>
                <div className="col-7 d-flex align-items-center">{record_data.customer_notes ? <p className='pt-1 pt-lg-4'>{record_data.customer_notes}</p>:''}</div>
                <div className="col-5 mb-2 border p-2">
                    <table className='table table-sm table-borderless mb-0'>
                        <tbody>
                            <tr>
                                <td className='border-top-0'><b>Sub Total</b></td>
                                <td className='border-top-0'>{computeSubTotals()}</td>
                            </tr>
                            {parseInt(discount_enabled) ?
                            <tr>
                                <td><b>Total Discount</b></td>
                                <td>{parseFloat(record_data.total_discount) > 0 ? helpers.formatCurrencyAmount(record_data.total_discount, default_currency) : '---'}</td>
                            </tr> : ''
                            }
                            <tr>
                                <td><b>Shipping Fee</b></td>
                                <td>{helpers.formatCurrencyAmount(record_data.shipping_fee, default_currency)}</td>
                            </tr>
                            {parseInt(tax_enabled) ?
                            <tr>
                                <td><b>Total Tax</b></td>
                                <td>{helpers.formatCurrencyAmount(record_data.total_tax, default_currency)}</td>
                            </tr> : ''
                            }
                            <tr className='bg-dark'>
                                <td><b>Total</b></td>
                                <td>{helpers.formatCurrencyAmount(record_data.total_amount, default_currency)}</td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>

            <div className="row border-top mt-5">
                <div className="col-12 text-center">
                    <small>Powered By Topventory Sales &amp; Inventory Solutions</small>
                </div>
            </div>
        </div>
    )
}